import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { InsertDriveFileOutlined } from '@mui/icons-material';
import { PatientDocument, PatientDocumentType } from '@uplift/api';
import { documentsMapping } from '../../../../../molecules/Modals/patient-chart-review-modal/components/PatientStaticDocument';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';


const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing('10px', 1),
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '&:hover': {
      boxShadow: theme.shadows[3]
    }
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    padding: '5px',
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
    borderRadius: '50%',
  },
  details: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    lineHeight: 1,
  }
}));


export type DocumentCardProps = {
  document: PatientDocument;
  onSelect?: (document: PatientDocument) => void;
};


export const DocumentCard: React.VFC<DocumentCardProps> = ({ document, onSelect }) => {
  const timezone = useTimezone();
  const { classes } = useStyles();
  const title = React.useMemo(() => {
    if (document.type === PatientDocumentType.form) {
      return document.form.name;
    }

    if (document.type === PatientDocumentType.static) {
      return documentsMapping[document.documentKey].title;
    }

    return document.reasonForUpload;
  }, [ document ]);

  return (
    <Paper
      className={classes.root}
      component="div"
      variant="outlined"
      onClick={() => {
        onSelect?.(document);
      }}
    >
      <Box className={classes.iconWrapper}>
        <InsertDriveFileOutlined fontSize="inherit" />
      </Box>
      <Box className={classes.details}>
        <Typography className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body2">uploaded by {document.uploadedBy} {CalendarDateService.format(document.uploadedAt, 'M/D', 'M/D, YYYY', { timezone })}</Typography>
      </Box>
    </Paper>
  );
};
